/**
 * Created by dreamc_t on 2017/4/7.
 */
require('./relateCss.scss');
let tmpl = require('./relatedNews.ejs');
let util = require('f.core.mobile.util');
let formatImage = require('./formatImg.js');

let relatedNews = function(options, native) {
    this.options = options;
    this.native = native;
    this.init();
};

let __getUrlParams = function() {
    let result = {};
    let params = window.location.search.substring(1).split('&');
    let param;

    for (let i = 0, iLen = params.length; i < iLen; i++) {
        param = params[i].split('=');
        if (param.length == 2) {
            result[param[0]] = decodeURIComponent(param[1]);
        }
    }

    return result;
};

let __urlParams = __getUrlParams();

let url = '//d.ifengimg.com/w104_h74/';
relatedNews.prototype.init = function() {
    this.info = this.options.info;
};

relatedNews.prototype.requestData = function() {
    let data = {
        column: this.info.columnId,
        page: 1,
        pagesize: 20,
        format: 'js',
        rt: 'jsonp'
    };
    return $.ajax({
        url: this.info.requestUrl,
        type: 'GET',
        data: data,
        cache: true,
        dataType: 'jsonp'
        // jsonpCallback: 'jsonpCallback'
    });
};

relatedNews.prototype.initDom = function(relateData) {
    if (!relateData.code) {
        let list = relateData.data.data;
        let item = [];
        let result = [];
        if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                item = list[i];
                if (item.id !== __urlParams.liveid) {
                    if (!this.native.isApp) {
                        item.link = '//izhibo.ifeng.com/live.html?liveid=' + item.id;
                    }
                    item.date = compareDate(item.starttime * 1000) || formatDate(item.starttime * 1000);
                    item.time = formatTime(item.starttime * 1000);
                    if (item.status + '' === '2') {
                        item.status = '预告';
                        item.statusClass = 'prefiled';
                    } else if (item.status + '' === '1') {
                        item.status = '直播中';
                        item.statusClass = 'active';
                    } else if (item.status + '' === '3') {
                        item.status = '回顾';
                        item.statusClass = 'end';
                    }
                    item.thumb = formatImage(item.thumb_new, 272, 123, 70);
                    result.push(item);
                }
            }
            this.el = $(tmpl({ items: result }));
            return this.el;
        } else {
            this.el = $(tmpl({ items: [] }));
            return this.el;
        }
    } else {
        console.log(relateData.msg);
    }
};

relatedNews.prototype.initEvent = function() {
    let self = this;
    this.elList = this.el[0].querySelector('.re-list');
    util.tap(
        this.elList,
        function(e) {
            if (self.native.isApp) {
                let from = this.dataset.from;
                let id = this.dataset.id;
                if (from == 'h5') {
                    self.native.openH5(id, self.options.info.mode);
                } else {
                    self.native.openNative(id);
                }
            } else {
                window.open('//izhibo.ifeng.com/live.html?liveid=' + this.dataset.id);
            }
        },
        {
            delegate: '.re-item'
        }
    );

    this.el[0].addEventListener('touchstart', function() {
        if (this.scrollTop === 0) {
            this.scrollTop = 1; // 防止拖动全页面
        }
    });
};

// 获取count天后的日期
function getDateStr(count) {
    let date = new Date();
    date.setDate(date.getDate() + count);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return year + '-' + add0(month) + '-' + add0(day);
}

function add0(m) {
    return m < 10 ? '0' + m : m;
}

// 日期格式化
function formatDate(time) {
    var time = new Date(time);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();

    return y + '-' + add0(m) + '-' + add0(d);
}

// 时间格式化
function formatTime(time) {
    var time = new Date(time);
    let h = time.getHours();
    let mm = time.getMinutes();

    return add0(h) + ':' + add0(mm);
}

// 判断今天、明天、昨天
function compareDate(time) {
    let date = formatDate(time);
    if (date === getDateStr(0)) {
        return '今天 ';
    } else if (date === getDateStr(1)) {
        return '明天 ';
    } else {
        return false;
    }
}

relatedNews.prototype.renderTo = function(parentNode) {
    let self = this;
    let request = Promise.resolve(this.requestData());
    request.then(function(data) {
        let ele = self.initDom(data);
        parentNode.innerHTML = '';
        parentNode.appendChild(ele[0]);
        self.initEvent();
    });
};

module.exports = relatedNews;



// WEBPACK FOOTER //
// ./app/modules/relatedNews/index.js